import { createSlice } from "@reduxjs/toolkit";
import { matchingCampaigns as initialState } from "../initialState";

const getMatchingCampaignsInitialState = () => initialState;

export const matchingCampaignsInitialState = getMatchingCampaignsInitialState();

const slice = createSlice({
    name: "matchingCampaigns",
    initialState: matchingCampaignsInitialState,
    reducers: {
        setMatchingCampaigns: (state, action) => action.payload,
    },
});

// action
export const { setMatchingCampaigns } = slice.actions;

// selectors
export const selectAllMatchingCampaigns = (state) =>
    state?.matchingCampaigns || {};

export const selectMatchingCampaignsSettings = (state) =>
    state?.matchingCampaigns?.settings || {};

export const selectActiveMatchingCampaign = (state) =>
    state?.matchingCampaigns?.activeCampaign || {};

export const selectHasActiveMatchingCampaign = (state) =>
    !!(Object.keys(state?.matchingCampaigns?.activeCampaign || {}).length > 0);

export default slice.reducer;
